import { useUserDataStore } from '../newStore/userDataStore';

export function usePermissionFlags() {
  const { permissions, currentUser } = useUserDataStore();

  const checkPermission = (permissionToCheck: string) => {
    if (permissions) {
      return permissions.some((permission: string) => permissionToCheck === permission);
    }
    return false;
  };

  const isAdminOrHasPermission = (permissionToCheck: string) => {
    return (
      currentUser?.is_admin ||
      currentUser?.is_superadmin ||
      currentUser?.is_support ||
      checkPermission(permissionToCheck)
    );
  };

  const hasPermissionForResumeBulkActions =
    checkPermission('evaluate_delete') || // Allow to delete or recover form answers.
    checkPermission('export') || // Allow to export form answers.
    checkPermission('evaluate'); // Allow to change status of form answers.

  return {
    permissions,
    checkPermission,
    isAdminOrHasPermission,
    hasPermissionForResumeBulkActions,
  };
}
